import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createI18n } from 'vue-i18n'

// импортируем переводы
import ru from './locales/ru.json'
import uz from './locales/uz.json'

const i18n = createI18n({
  legacy: false,
  locale: 'ru',        // язык по умолчанию
  fallbackLocale: 'ru',
  warnHtmlMessage: false,
  messages: {
    ru,
    uz
  }
})

createApp(App).use(router).use(i18n).mount('#app')
